import { SVGProps } from 'react'

function PaperAirplane(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={145}
      height={145}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M33.985 96.062v44.679c0 4.078 5.202 5.8 7.649 2.555l21.822-29.09 6.652-3.408L142.137 8.936l1.341-7.921-11.709 6.47-97.802 84.916.018 3.661Z"
          fill="#959595"
        />
        <path
          d="M139.13.343c-.2.072-136.59 68.549-136.79 68.64-2.972 1.486-3.153 5.672-.326 7.412l31.973 19.666L143.48 1.031c-1.106-.96-2.701-1.377-4.35-.688Z"
          fill="#CBCBCB"
        />
        <path
          d="M143.623 1.232c-.055-.054-.073-.145-.145-.217l-.834 1.178-79.207 112.013 49.011 30.16c2.555 1.576 5.854.072 6.398-2.828l26.082-136.5c.271-1.45-.309-2.845-1.305-3.806Z"
          fill="#B3B3B3"
        />
        <path
          d="M119.625 145C133.639 145 145 133.639 145 119.625S133.639 94.25 119.625 94.25 94.25 105.611 94.25 119.625 105.611 145 119.625 145Z"
          fill="#E72369"
        />
        <path
          d="m131.569 127.636-8.011-8.011 8.011-8.011-3.933-3.933-8.011 8.011-8.011-8.011-3.933 3.933 8.011 8.011-8.011 8.011 3.933 3.933 8.011-8.011 8.011 8.011 3.933-3.933Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h145v145H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

PaperAirplane.defaultProps = { role: 'graphics-document' }

export default PaperAirplane
